// Configuration for different environments

// For LOCAL Environment
// const BASEURL = "http://localhost:5000/api";
// const DEP_ENVIRONMENT = "prod";

// For PROD Environment
const BASEURL = "https://prod-mid.dep-vygr.com/api";
const DEP_ENVIRONMENT = "prod";

// Common configuration
const AWS_CONFIG_TYPE = true;
const CLOUD_ENVIRONMENT = "AWS";

export { BASEURL, AWS_CONFIG_TYPE, CLOUD_ENVIRONMENT, DEP_ENVIRONMENT };
